import React, { useState } from "react";
import { gql, useMutation } from "@apollo/client";
import "../styles/Admin.css";

const INSERT_ADMIN = gql`
  mutation InsertAdmin(
    $nom: String!
    $prenom: String!
    $email: String!
    $telephone: String
    $password: String!
  ) {
    insert_admins_one(
      object: {
        nom: $nom
        prenom: $prenom
        email: $email
        telephone: $telephone
        password: $password
      }
    ) {
      id
      nom
      prenom
      email
      telephone
      created_at
    }
  }
`;

function CreateAdmin() {
  const [form, setForm] = useState({ nom: "", prenom: "", email: "", telephone: "", password: "" });
  const [touched, setTouched] = useState(false);
  const [insertAdmin, { loading, error, data } ] = useMutation(INSERT_ADMIN);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((f) => ({ ...f, [name]: value }));
  };

  const isValid = () => form.nom.trim() && form.prenom.trim() && /.+@.+\..+/.test(form.email) && form.password.length >= 8;

  const handleSubmit = async (e) => {
    e.preventDefault();
    setTouched(true);
    if (!isValid()) return;
    try {
      await insertAdmin({ variables: form });
      setForm({ nom: "", prenom: "", email: "", telephone: "", password: "" });
      setTouched(false);
    } catch (_) {}
  };

  return (
    <div style={{ maxWidth: 560, margin: "20px auto" }}>
      <h2>Ajouter un administrateur</h2>
      <form onSubmit={handleSubmit} className="form-row">
        <div className="form-group">
          <label htmlFor="nom">Nom</label>
          <input id="nom" name="nom" type="text" className="form-input" value={form.nom} onChange={handleChange} required />
        </div>

        <div className="form-group">
          <label htmlFor="prenom">Prénom</label>
          <input id="prenom" name="prenom" type="text" className="form-input" value={form.prenom} onChange={handleChange} required />
        </div>

        <div className="form-group">
          <label htmlFor="email">Email</label>
          <input id="email" name="email" type="email" className="form-input" value={form.email} onChange={handleChange} required autoComplete="email" />
          {touched && !/.+@.+\..+/.test(form.email) && <span style={{ color: "#c32015", fontSize: 13 }}>Email invalide</span>}
        </div>

        <div className="form-group">
          <label htmlFor="telephone">Téléphone (optionnel)</label>
          <input id="telephone" name="telephone" type="tel" className="form-input" value={form.telephone} onChange={handleChange} />
        </div>

        <div className="form-group">
          <label htmlFor="password">Mot de passe</label>
          <input id="password" name="password" type="password" className="form-input" value={form.password} onChange={handleChange} required autoComplete="new-password" minLength={8} />
          {touched && form.password.length < 8 && <span style={{ color: "#c32015", fontSize: 13 }}>8 caractères minimum</span>}
        </div>

        <button className="form-submit" type="submit" disabled={loading || !isValid()}>
          {loading ? "Création..." : "Créer l'admin"}
        </button>

        {data && <p style={{ color: "green", margin: "8px 0 0" }}>Administrateur créé avec succès.</p>}
        {error && <p style={{ color: "#c32015", margin: "8px 0 0" }}>Erreur: {error.message}</p>}
      </form>
    </div>
  );
}

export default CreateAdmin;

